<template>
	<div class="add_backimgIndex">
		<div class="main_banner clearfix">
			<img src="@/images/main_banner.png" class="l" />
		</div>

		<div class="main_content">
			<div class="main_nav">
				中心概况
				<span class="r">
				首页>中心概况
			</span>
			</div>
			<div class="main_tetiel">
				实验教学中心（虚拟仿真类）名称：智能医学影像与放射治疗虚拟仿真实验教学中心
			</div>
			<div class="main_tetiel">
				专业类：医学技术类（1010）、生物医学工程类（0826）
			</div>
			<div class="main_label">学校实验教学中心总体建设规划概述</div>
			<div class="main_text">
				山东第一医科大学整体谋划，把虚拟仿真实验教学中心作为实验教学的重要分支，重点开展资源、平台、队伍和制度等方面的建设，形成了持续服务实验教学，保证优质实验教学资源开放共享的有机整体。
			</div>
			<div class="main_text main_textbord">
				（1）虚拟仿真实验教学中心资源建设
			</div>
			<div class="main_text">
				充分体现学校学科专业优势，积极利用企业的开发实力和支持服务能力，系统整合学校信息化实验教学资源，创造性地建设与应用软件共享虚拟实验、仪器共享虚拟实验和远程控制虚拟实验等优质教学资源，推动信息化条件下自主学习、探究学习、协作学习等实验教学方法改革，提高教学能力，丰富教学内容，拓展实践领域，降低成本和风险，开展绿色实验教学。支持鼓励自主创新和拥有自有知识产权。
			</div>
			<div class="main_text main_textbord">
				（2）虚拟仿真实验教学中心管理与共享
			</div>
			<div class="main_text">
				按照服务与资源相结合的原则，建设学校统一的具有开放性、扩展性、兼容性、前瞻性的虚拟仿真实验教学管理和共享平台，高效管理实验教学资源，全面提供搜索导航服务，及时发布资源应用信息，切实扩大资源影响力度，实现校内外、本地区及更大范围内的实验教学资源共享，满足多学科专业、多学校和多地区开展虚拟仿真实验教学的需要。探索高等学校、科研院所、行业企业共建共管共享的新模式，构建可持续发展的虚拟仿真实验教学服务支撑体系。
			</div>
			<div class="main_text main_textbord">
				（3）虚拟仿真实验教学中心管理队伍建设
			</div>
			<div class="main_text">
				建设教学、科研、技术、管理人员相结合，核心骨干人员相对稳定，年龄、职称、知识、能力结构合理的虚拟仿真实验教学团队，形成教育理念先进，教学科研水平高，信息技术应用能力强，实践经验丰富，团结协作、勇于创新的虚拟仿真实验教学队伍。
			</div>
			<div class="main_text main_textbord">
				（4）虚拟仿真实验教学中心管理体系建设
			</div>
			<div class="main_text">
				以虚拟仿真实验教学资源的充分使用和更大范围开放共享为目标，系统制定并有效实施保障虚拟仿真实验教学的教师工作绩效考核、经费使用管理、实验教学中心维护与可持续发展等政策措施，建立有利于激励学生学习和提高学生创新能力的教学效果考核、评价和反馈机制。
			</div>
			<img src="@/images/main_img1.png" class="main_img" />
			<div class="main_label">本实验教学中心发展历程、整体概况</div>
			<div class="main_text">
				医学影像及肿瘤放射治疗在现代医学诊疗中越来越重要，高素质医学影像及放射治疗相关人才对于国家医疗健康战略具有重要支撑作用。医学影像及放射治疗相关专业课程是医师、物理师、技师和工程师核心素养和能力的基础，而仅关注结果的真机实验无法满足成像理论的过程化展示，批量化、规范化的成像理论实验一直无法开展，使得从业人员的专业素质得不到有效提高，可持续发展能力不足，因此针对涉及大型昂贵、有危险性的医学影像仪器相关的高素质专业人才培养和培训的核心问题需要通过创新性的手段来解决。
			</div>
			<div class="main_text">
				针对上述问题， 智能医学影像与放射治疗虚拟仿真实验教学中心在学校实验教学中心总体建设框架下，在高等教育层次，普适性、应用面广的领域已广泛开展数字化教育软件研发和应用的大背景下应时而生。
			</div>
			<div class="main_text main_textbord">
				（1）中心发展历程
			</div>
			<div class="main_text">
				本实验中心研发了实验效果逼真度高、实时性强、操作体验佳的系列医学影像仿真实验，包括数字X射线摄影（DR）设备、计算机断层成像（CT）设备、磁共振成像（MRI）设备、医学影像检查技术、医学影像成像原理和医学影像诊断、常见放疗设备及质控设备、放疗工作流程等虚拟仿真实验项目，并经历了建设积累、整合发展、集成创新和示范建设等阶段。
			</div>
			<img src="@/images/main_img2.png" class="main_img" />
			<div class="main_text main_textbord">
				（2）整体概况
			</div>
			<div class="main_text">
				本中心自成立以来获软件著作权20余项，基于本成果仿真仪器开发的仿真实验项目分别纳入十三五规划教材等各类教材4本；发表研究论文10余篇，教学服务用户包括四川大学、重庆医科大学、南京医科大学、首都医科大学、上海健康医学院等40余所高校，培养实验教学师资150余人。
			</div>
			<img src="@/images/main_img3.png" class="main_img" />
			<div class="main_label">本实验教学中心近三年工作措施</div>
			<div class="main_text">
				智能医学影像及放射治疗虚拟仿真实验教学中心近三年的工作举措如下：
			</div>
			<div class="main_text main_textbord">
				（1）建立了“一个核心，两种方式，三个结合，四个能力”的实践教学模式
			</div>
			<div class="main_text">
				“一个核心”指紧密围绕培养学生实践创新能力为核心；“两种方式”指有效利用线下实景实验教学和虚拟仿真实验教学两种有效措施；“三个结合”指虚拟仿真和现场实验密切结合、人文素质教育和技能教育密切结合、课堂教学和泛在式教学密切结合的实践教学模式；“四个能力”指培养学生的岗位胜任能力、实践创新能力、批判性思维能力、终身学习能力。
			</div>
			<div class="main_text main_textbord">
				（2）构建了“虚实结合、资源共享、创新引领、突出特色”的实践教学体系
			</div>
			<div class="main_text">
				中心按照“培养实践能力强、具有创新能力的应用研究型人才”的人才培养定位，以提高学生创新精神和实践能力为宗旨，坚持以学生为本，融入人文关怀和医学伦理，以项目资源建设为核心，系统平台建设为基础，教学理念转变为支点，制度体系建设为保证，教学队伍建设为关键，积极构建“虚实结合、资源共享、创新引领、突出特色”的虚拟仿真实践教学体系。
			</div>
			<div class="main_text main_textbord">
				（3）延伸了虚拟仿真实验教学中心平台职能
			</div>
			<div class="main_text">
				近三年连续利用中心平台承办“泰山杯”全国医学影像技术专业实践技能大赛虚拟仿真项目比赛，并在医学影像技术联盟内连续两年开展了职业能力综合测试技能考核，为中心建设探索了发展路径，奠定了学科基础，提供了项目资源，起到了辐射引领的作用。通过中心建设，不仅带好了一支队伍，产出了一批教学建设成果，更是能够起到示范引领的作用。
			</div>
			<div class="main_text main_textbord">
				（4）发挥了自由度大，安全性高，灵活创新的建设优势
			</div>
			<div class="main_text">
				近三年的线上学习期间，学生充分利用虚拟仿真实验项目进行实验,不受时间及空间的限制, 甚至可以利用网络化手段提高效率。进入虚拟仿真实验教学中心, 学生能够更灵活地选择实验系统, 根据目标需求的不同,进行实验测试。充分发挥了医学影像虚拟仿真实验教学中心的建设优势。
			</div>
			<div class="main_label">本实验教学中心运行制度建设情况</div>
			<div class="main_text">
				为优化中心教学仪器设备的管理和使用，本中心制定了《智能医学影像及放射治疗虚拟仿真实验教学中心管理制度》等一系列规章制度。对设施设备、岗位职责、开放管理、软件维护等方面进行了严格的管理，从制度上保证了中心的正常、安全以及高效的运转。
			</div>
			<img src="@/images/main_img4.png" class="main_img" />
			<div class="main_text main_textbord">
				（1）教师和学生有关规章制度
			</div>
			<div class="main_text">
				①智能医学影像与放射治疗虚拟仿真实验教学中心学生实验守则
			</div>
			<div class="main_text">
				②智能医学影像与放射治疗虚拟仿真实验教学中心档案工作管理规定
			</div>
			<div class="main_text">
				③智能医学影像与放射治疗虚拟仿真实验教学中心实验技术人员岗位职责
			</div>
			<div class="main_text">
				④智能医学影像与放射治疗虚拟仿真实验教学中心开放管理规章制度
			</div>
			<div class="main_text">
				⑤智能医学影像与放射治疗虚拟仿真实验教学中心主任职责
			</div>
			<div class="main_text">
				⑥智能医学影像与放射治疗虚拟仿真实验教学中心实验指导教师职责要求
			</div>
			<div class="main_text">
				⑦智能医学影像与放射治疗虚拟仿真实验教学中心学生守则
			</div>
			<div class="main_text main_textbord">
				（2）实验中心开放运行相关制度
			</div>
			<div class="main_text">
				①智能医学影像与放射治疗虚拟仿真实验教学中心开放管理办法
			</div>
			<div class="main_text">
				②智能医学影像与放射治疗虚拟仿真实验教学中心综合性、设计性实验管理暂行规定
			</div>
			<div class="main_text">
				③智能医学影像与放射治疗虚拟仿真实验教学中心开放管理制度
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {

			}
		},
		created() {

		},
		mounted() {

		},
		methods: {

		},
	}
</script>